import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './views/login/login';
import ResultPage from './views/result-page/ResultPage';
import TestApis from './views/test-apis/TestApis';
import { Provider } from 'react-redux';
import MyFilesTable from './views/dashboard/MyFilesTabel';
import ProtectedRoute from './components/Protection/ProtectedRoute';
import { useEffect } from 'react';
import GestionUsers from './views/gestion-utilisateur/GestionUsers';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Documentation from './views/documentation/Documentation';
import StatsRma from './views/stats/StatsRma';
import { isCurrentSession, isTokenExpired } from './utils/session';

// Un utilisateur déjà connecté n'a pas à revoir la page de connexion.
const LoginRoute = () => {
  if (isCurrentSession()) {
    if (!isTokenExpired()) return <Navigate to="/dashboard" replace />;
    localStorage.clear();
  }
  return <Login />;
};

const App = () => {
  useEffect(() => {
    document.title = "Check AI"; // Set global title
  }, []);
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={4000} />
      <Routes>
        <Route path="/" element={<LoginRoute />} />
        <Route path="/result-page/:code" element={<ProtectedRoute element={<ResultPage />} />} />        
        <Route path="/test-apis" element={<ProtectedRoute element={<TestApis />} />} />
        <Route path="/test-apis/:code" element={<ProtectedRoute element={<TestApis />} />} />
        <Route path="/admindash" element={<ProtectedRoute element={<GestionUsers />} />} />
        <Route path="/dashboard" element={<ProtectedRoute element={<MyFilesTable />} />} />
        <Route path="/Documentation" element={<ProtectedRoute element={<Documentation />} />} />
        <Route path="/stats" element={<ProtectedRoute element={<StatsRma />} />} />
        
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
        
      </Routes>
    </Router>
  );
};


export default App;
